import React from 'react';
import SidebarDropDownOption from '../../../../components/SidebarDropDownOption';
import { Link } from 'react-router-dom';
import {useSelector } from 'react-redux';
import routes from "../../../../Routes/routes";
import SubMenu from "../../../../components/Sidebar/SubMenu";
import {IconsSideBar} from "../Functionality/IconsSideBar";
import {STATUS_MODEL} from "../../../../enums/statusEnum";
import CommonTabsApp from "../Functionality/CommonTabsApp";
import {MENU_NAME_MODEL} from "../../../LoginOption/Model/Model";
import { useTranslation } from 'react-i18next';
import { sortMenuByLabel } from "../../../../Helpers/sortMenuByLabel";

const ProviderTabs = ({ isMenuOpen }) => {
    const props = CommonTabsApp();
    const { openMenu, changeStyle, setChangeStyle, isHovering, setIsHovering,
        handleMenuToggle, handleMenuItemClick} = props;
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const { t } = useTranslation();

    const menuItems = [
        {
            name: MENU_NAME_MODEL.EMPLOYEES,
            url: routes.suppliers.employees,
            label: 'employees',
            onlyName: true,
            icon: IconsSideBar.icEmployees,
            isHovering: 4,
            hasPermission: '',
        },
        {
            name: MENU_NAME_MODEL.VEHICLES,
            url: routes.suppliers.vehicleFleet,
            label: 'vehicle_fleet',
            onlyName: true,
            icon: IconsSideBar.icVehicleFleet,
            isHovering: 5,
            hasPermission: '',
        },
        {
            name: MENU_NAME_MODEL.ORDERS,
            url: routes.suppliers.orders,
            label: 'purchase_order',
            onlyName: true,
            icon: IconsSideBar.icSupplier,
            isHovering: 7,
            hasPermission: '',
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: MENU_NAME_MODEL.PROFILE,
            url: routes.suppliers.profile,
            label: 'profile',
            onlyName: true,
            icon: IconsSideBar.icProfile,
            isHovering: 21,
            hasPermission: '',
        },
        {
            name: MENU_NAME_MODEL.TRANSPORT_REQUEST,
            url: routes.suppliers.transportRequest,
            label: 'transport_request',
            onlyName: true,
            icon: IconsSideBar.icTransportRequest,
            isHovering: 35,
            hasPermission: '',
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: MENU_NAME_MODEL.FOODIE_DINING,
            url: routes.suppliers.foodie,
            label: 'foodie_dining',
            onlyName: true,
            icon: IconsSideBar.icCafeteria,
            isHovering: 36,
            hasPermission: '',
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: MENU_NAME_MODEL.COMPANY_DOCUMENTATION,
            url: routes.suppliers.companyDocumentation,
            label: 'company_documentation',
            onlyName: true,
            icon: IconsSideBar.icCompanyDocumentation,
            isHovering: 8,
            hasPermission: true
        },
    ];

    return (<>
        <ul className={isMenuOpen ? 'largeMenu' : 'shortMenu'}>
            {/* Options ascending by the label shown in the active language */}
            {sortMenuByLabel(menuItems, (item) => t(item.label))
                .filter((item) => !item.hide)
                .map((item, index) => (
                <SubMenu
                    key={index}
                    name={item.name}
                    isMenuOpen={isMenuOpen}
                    url={item.url}
                    isHovering={isHovering}
                    numHovering={item.isHovering}
                    label={item.label}
                    menuId={`menu-${index}`}
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    setChangeStyle={setChangeStyle}
                    onClick={() => handleMenuItemClick(item.name)}
                    changeStyle={changeStyle}
                    Icon={item.icon}
                    onLeave={() => setIsHovering(0)}
                    onHover={() => setIsHovering(item.isHovering)}
                    onlyName={item.onlyName}
                />
            ))}
            <Link to='#'>
                <li className={isMenuOpen ? 'profile_li' : 'profile_li_col'}>
                    <SidebarDropDownOption
                        changestyle={changeStyle}
                        hovereffect={isHovering}
                        isMenuOpen={isMenuOpen}
                        menutop={false}
                    />
                </li>
            </Link>
        </ul>
        <div className='border-bottom border-white'/>
        </>
    );
};

export default ProviderTabs;

